// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"8b158ac2","453":"32734b96","484":"a87d9214","634":"a4c53ca7","688":"0b4f884f","738":"154fb8a3"}[chunkId] + ".chunk.js";
};